import { fetchWithAuthRetry, filenameFromContentDisposition } from './apiUtils';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

export interface CertificatePreviewResult {
  blob: Blob;
  filename: string;
}

/**
 * POST /courses/:courseId/certificate/preview — NA-65 author preview.
 * author-api HMAC-signs the actual hoot-server call; this endpoint's response
 * is a raw PDF, not JSON, so the caller streams it into a Blob rather than
 * going through the JSON-shaped `handleApiResponse` helper.
 */
export async function fetchCertificatePreview(
  courseId: string,
  accountId?: number | null,
  locale?: string | null
): Promise<CertificatePreviewResult> {
  const body: { externalAccountId?: number; locale?: string } = {};
  if (accountId) body.externalAccountId = accountId;
  if (locale) body.locale = locale;

  const response = await fetchWithAuthRetry(`${API_BASE_URL}/courses/${courseId}/certificate/preview`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({ message: 'Certificate preview failed' }));
    throw new Error(typeof body.message === 'string' ? body.message : 'Certificate preview failed');
  }

  const blob = await response.blob();
  const filename =
    filenameFromContentDisposition(response.headers.get('content-disposition')) ?? 'completion_certificate.pdf';
  return { blob, filename };
}
